module.exports = __webpack_public_path__ + "static/media/400097_02.ae561de6.png";